import React, { useEffect, useState } from 'react';
import { Form, Row, Col, DatePicker, Image, Typography, Alert, Flex } from 'antd';
import CustomInput from '../../../components/CustomInput/Input';
import CustomSelect from '../../../components/CustomSelect/CustomSelect';
import CustomButton from '../../../components/CustomButton/Button';
import DatePickerIcon from '../../../assets/icons/datepicker-calendar.svg';
import { nameRules, phoneNumberRules } from '../../../helpers/helpers';
import { useDispatch, useSelector } from 'react-redux';
import { getAllRelations } from '../../../redux/slices/ProfileSlice';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { BTN_TXT, ERROR_MSGS, TITLE_TXT } from '../../../constants/constants';
import CountryCode from '../../../components/CountryCodeSelect/CountryCode';
import dayjs from 'dayjs';

const { Title } = Typography;

const NomineeForm = ({
    initialValues = {},
    onSubmit,
    loading,
    error,
    mode = "add", // "edit"
    onBack
}) => {
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const { relations } = useSelector((state) => state.profile);
    const [isButtonDisabled, setIsButtonDisabled] = useState(mode === "add");

    useEffect(() => {
        dispatch(getAllRelations());
    }, [dispatch]);

    useEffect(() => {
        if (mode === "edit") {
            form.setFieldsValue(initialValues);
        }
    }, [form, initialValues, mode]);

    const handleFieldsChange = (_, allFields) => {
        const allFieldsFilled = allFields.every(field => field.errors.length === 0 && field.value);
        setIsButtonDisabled(!allFieldsFilled);
    };

    return (
        <div className='investor-details-container'>
            <div className='header-container'>
                <Flex gap={10} align="center">
                    {mode === "edit" && (
                        <CustomButton onClick={onBack} type="text" shape="circle" icon={<ArrowLeftOutlined />} style={{ padding: 0 }} />
                    )}
                    <Title level={4}>{mode === "edit" ? TITLE_TXT.EDIT_NOM_DETS : TITLE_TXT.ADD_NOM_DETS}</Title>
                </Flex>
            </div>
            <div className='details-container'>
                <Form
                    layout="vertical"
                    form={form}
                    onFinish={onSubmit}
                    onFieldsChange={handleFieldsChange}
                    initialValues={{ countryCode: "91", ...initialValues }}
                    className="change-password-form"
                >
                    <Row gutter={[16, 0]}>
                        <Col xs={24} lg={10}>
                            <CustomInput
                                label="Nominee Legal Name"
                                name="nomineeName"
                                placeholder="Enter Name"
                                type="text"
                                rules={nameRules("")}
                            />
                        </Col>
                        <Col xs={24} lg={10}>
                            <Form.Item
                                label="Nominee Date of Birth"
                                name="nomineeDob"
                                rules={[{ required: true, message: ERROR_MSGS.ENTER_NOM_DOB }]}
                                className="custom-input"
                            >
                                <DatePicker
                                    format="DD/MM/YYYY"
                                    placeholder="Enter DOB"
                                    suffixIcon={<Image src={DatePickerIcon} preview={false} />}
                                    disabledDate={(current) => current && current > dayjs().endOf('day')}
                                />
                            </Form.Item>
                        </Col>
                        <Col xs={24} lg={10}>
                            <CustomSelect
                                label="Relationship"
                                name="relationship"
                                className="custom-relation-select"
                                placeholder="Select Relation"
                                options={relations.map(rel => ({
                                    value: rel.relationId,
                                    label: rel.relationName.replace(/_/g, " ")
                                }))}
                                rules={[{ required: true, message: ERROR_MSGS.SEL_REL }]}
                            />
                        </Col>
                        <Col xs={24} lg={10}>
                            <CustomInput
                                label="Phone Number"
                                name="phoneNumber"
                                placeholder="Enter Phone Number"
                                addonBefore={<CountryCode />}
                                rules={phoneNumberRules("")}
                            />
                        </Col>
                    </Row>
                    {error && (
                        <Row>
                            <Col xs={24} lg={20}>
                                <Alert style={{ marginBottom: 20 }} message={error} type="error" showIcon />
                            </Col>
                        </Row>
                    )}
                    <Row>
                        <Col xs={24} lg={20}>
                            <CustomButton
                                type="primary"
                                htmlType="submit"
                                block
                                loading={loading}
                                disabled={isButtonDisabled}
                            >
                                {mode === "edit" ? BTN_TXT.SAVE_CHNG : BTN_TXT.SAVE}
                            </CustomButton>
                        </Col>
                    </Row>
                </Form>
            </div>
        </div>
    );
};

export default NomineeForm;
